import React, {useRef} from "react";
import {getFile} from "../../../api/file/FileService";
import AttachmentCollapsibleList from "../../../components/files/AttachmentCollapsibleList";
import AttachmentFileList, {getAttachmentFileName} from "../../../components/files/AttachmentFileList";
import AttachmentListUploader from "../../../components/files/AttachmentListUploader";
import {appendDocFiles} from "../../../components/files/createAttachHelpers";
import {getVisibleDocs, removeAttachItem} from "../../../components/files/editAttachState";

export default function WorkAttachField({attachState, setAttachState, readOnly = false, variant = "kv"}) {
    const docIdRef = useRef(0);
    const visibleDocs = getVisibleDocs(attachState);
    const listItems = visibleDocs.map((item) => ({
        ...item,
        originalName: getAttachmentFileName(item),
    }));

    if (readOnly) {
        if (!listItems.length) return null;

        return (
            <AttachmentCollapsibleList
                items={listItems}
                onOpen={(item) => getFile(item)}
            />
        );
    }

    const uploaderClass = variant === "kv" ? "attch-uploader--kv-inline" : "";

    return (
        <AttachmentListUploader
            className={uploaderClass}
            inputId={`work_attach_${docIdRef.current}`}
            onInputChange={(e) => {
                setAttachState((prev) => ({
                    ...prev,
                    pendingDocs: appendDocFiles(prev.pendingDocs, e.target.files, docIdRef),
                }));
                e.target.value = "";
            }}
            hasFiles={listItems.length > 0}
            fileList={(
                <AttachmentFileList
                    items={listItems}
                    onRemove={(item) => removeAttachItem(setAttachState, item, "doc")}
                    hoverPreview
                    onOpen={(item) => {
                        if (item.object) return;
                        getFile(item);
                    }}
                />
            )}
        />
    );
}
